import { Progress } from "antd";

export const CustomProgress = ({ textColor = "#E4B228", fontSize = 60, width = 500, height = 500, marginBottom = -225, percent = 0, strokeColor = "#FBC42C", trailColor = "#FEEDBE", type = 'dashboard', customText, strokeLinecap = 'square', showInfo = true }) => (
  <Progress
    width={'100%'}
    style={{ maxWidth: width, width: '100%', marginBottom, height }}
    className={`custom-progress ${type === 'dashboard' ? 'dashboard' : ''}`}
    showInfo={showInfo}
    format={(percent) => (
      <span style={{ color: textColor, fontWeight: 600, fontSize }}>{customText ? customText : `${isNaN(percent) ? 0 : percent}%`}</span>
    )}

    strokeColor={{ "0%": strokeColor, "100%": strokeColor }}
    type={type}
    strokeLinecap={strokeLinecap}
    trailColor={trailColor}
    percent={isNaN(percent) ? 0 : percent}
    gapDegree={type === 'dashboard' ? 180 : 0}
  />
);
